import { Pipe, PipeTransform } from '@angular/core';
import { UAParser } from 'ua-parser-js';

@Pipe({
  name: 'uaParser',
  standalone: true,
})
export class UaParserPipe implements PipeTransform {
  transform(value: string): string {
    const deviceDetail = new UAParser().setUA(value).getResult();
    console.log('deviceDetail', deviceDetail);
    return `${deviceDetail?.browser?.name || ''} ${deviceDetail?.device?.vendor || ''} ${
      deviceDetail?.os?.name || ''
    } `.trim();
  }
}
